
/**
 * Extracts the domain part from an email address
 * @param email The email address
 * @returns The domain part of the email
 */
export function extractDomain(email: string): string {
  if (!email || !email.includes('@')) {
    return '';
  }
  
  const parts = email.split('@');
  return parts[1];
}
